import { createSelector } from "reselect";
import { AppState } from "../../index";
import { getABTestsOperation } from "../operations";

const getABTests = (state: AppState) => state.abTests;

export const getActiveABTests = createSelector(getABTests, getABTestsOperation.getStatus, (abTests, status) =>
    status === "complete" || status === "failed" ? abTests ?? null : undefined
);
